<script setup>
defineOptions({
  name: 'Login',
});
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const password = ref('');
const hidePassword = ref(true);
const isLoading = ref(false);
const passwordFieldIcon = computed(() =>
  hidePassword.value ? 'icon-eye-off-1' : 'icon-eye-1'
);
const passwordFieldType = computed(() =>
  hidePassword.value ? 'password' : 'text'
);

const user_name = ref('');
const router = useRouter();
const handleSubmit = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('submitLogin', {
      user_name: user_name.value,
      password: password.value,
    });
    router.push({ name: `TherapyMenu` });
  } catch (err) {
    console.log(err);
  }
  isLoading.value = false;
};
</script>
<template>
  <div class="login">
    <div class="hero is-fullheight is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <div class="column is-14 is-offset-2">
            <p class="title is-2 has-text-weight-bold has-text-white">
              Please log in
            </p>
            <form @submit.prevent="handleSubmit" name="loginform">
              <div class="field">
                <div class="control">
                  <input
                    v-model.trim="user_name"
                    class="input is-large"
                    name="user_name"
                    type="text"
                    placeholder="Username"
                    autofocus=""
                  />
                </div>
              </div>

              <div class="field">
                <p class="control has-icons-right">
                  <input
                    v-model.trim="password"
                    class="input is-large"
                    :type="[passwordFieldType]"
                    placeholder="Password"
                    name="password"
                  />
                  <span class="icon is-large is-right">
                    <i
                      :class="[passwordFieldIcon]"
                      class="icon-click"
                      @click="hidePassword = !hidePassword"
                    ></i>
                  </span>
                </p>
              </div>
              <div class="field">
                <button
                  type="submit"
                  class="button is-block is-danger is-large is-fullwidth"
                  :class="isLoading ? 'is-loading' : ''"
                >
                  Log in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.login {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
